import { useEffect } from "react";
import { initLenis } from "@/lib/lenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/Marquee";
import { Intro } from "@/components/landing/Intro";
import { Symptoms } from "@/components/landing/Symptoms";
import { Outcomes } from "@/components/landing/Outcomes";
import { Journey } from "@/components/landing/Journey";
import { Included } from "@/components/landing/Included";
import { Pricing } from "@/components/landing/Pricing";
import { About } from "@/components/landing/About";
import { Testimonials } from "@/components/landing/Testimonials";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div data-testid="landing-page" className="bg-cream text-soil">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Intro />
        <Symptoms />
        <Outcomes />
        <Journey />
        <Included />
        <Pricing />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
